module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Gg1jpW/images/more-fool-me.jpg?1733151169013",
      "alt": "This image is the cover for the book More Fool Me"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("More Fool Me\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A woman embarks on a fresh start—but misplaced trust could end it all, in this knife’s-edge psychological thriller by the author of "), _c('i', [_vm._v("The Desperate Wife")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v(" In the shadowy streets of Hull, Paige Carrigan tries to forage a brand-new life, but is still haunted by a past that refuses to stay buried. Orphaned and once entrapped by an abusive ex, but now eerily close to freedom, she finds solace in her writing and in a local group of people with secrets of their own."), _c('br'), _c('br'), _vm._v(" But as Paige’s first proofreading client draws her into an enthralling yet unsettling romance, her fragile peace is shattered by a sinister text message: "), _c('i', [_vm._v("You can run but you can’t hide.")]), _c('br'), _c('br'), _vm._v(" With each new chapter she writes, the line between fiction and reality blurs—exposing a web of deceit spun by those she depends on most. Can Paige unmask the truth before her life mirrors her own tragic tales?"), _c('br'), _c('br'), _vm._v(" From the author of "), _c('i', [_vm._v("Sunday’s Child")]), _vm._v(" and "), _c('i', [_vm._v("What’s Mine Is Yours")]), _vm._v(", "), _c('i', [_vm._v("More Fool Me")]), _vm._v(" is a gripping page-turner in which trust is a double-edged sword, and betrayal may be the only means of survival.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      C. L. Jennison\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0